class Bill {
    constructor (
        ci_nit = null
    )
    {
        this.ci_nit = ci_nit;
    }
}
export default Bill;